import { getCarAuthToken, getCarOpenId, getUrlActivityCode, getUrlUid } from './auth.js'
import {
	fetchCarUserState,
	getCarActivityUserId,
	submitCarSurvey,
	validateSealForCar
} from './signstore-api.js'
import { cvQuery } from '../utils/dom.js'

export function openId() {
	return getCarOpenId()
}

export function token() {
	return getCarAuthToken()
}

export function showToast(type, message, duration) {
	const box = cvQuery('#toastBox')
	const mask = cvQuery('#toastMask')
	if (!box) return
	box.className = 'toast-box show toast-' + type
	const msgEl = box.querySelector('.toast-msg')
	if (msgEl) msgEl.textContent = message
	if (mask) mask.classList.add('show')
	clearTimeout(showToast._t)
	showToast._t = setTimeout(function () {
		box.classList.remove('show')
		if (mask) mask.classList.remove('show')
	}, duration || 3000)
}

export const getUserInfo = async function () {
	const activityCode = getUrlActivityCode()
	const uid = getUrlUid()
	return fetchCarUserState(activityCode, uid)
}

export const setAnswer = async function (params) {
	if (!getCarActivityUserId()) {
		throw new Error('用户参与记录未就绪')
	}
	const payload = params && typeof params === 'object' ? params : {}
	try {
		await submitCarSurvey({
			q1Text: payload.q1Text,
			q1Answer: payload.q1Answer,
			q2Text: payload.q2Text,
			q2Answer: payload.q2Answer,
			q3Text: payload.q3Text,
			q3Suggestion: payload.q3Suggestion
		})
		return { code: 200, message: '提交成功' }
	} catch (error) {
		const msg = error && error.message ? String(error.message) : '提交失败'
		if (/已经提交/.test(msg)) {
			return { code: 200, message: msg }
		}
		throw error
	}
}

export const logData = async function () {
	return { code: 200, message: '打卡成功' }
}

export const logDaka = async function () {
	throw new Error('打卡服务器错误1')
}

function preventTouchMove(e) {
	e.preventDefault()
}

export function bindScrollLock(el) {
	if (!el) return
	el.style.display = 'none'
	el.addEventListener('touchmove', preventTouchMove, { passive: false })
	el.removeEventListener('touchmove', preventTouchMove, { passive: false })
}

export const verifyCode = async function (point, ruleCode) {
	return validateSealForCar(point, ruleCode)
}

export function clearCanvas(checkinCanvas) {
	const canvas = cvQuery('.' + checkinCanvas)
	if (!canvas) return
	const ctx = canvas.getContext('2d')
	if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height)
}

export function watchKeyboardByVisualViewport(callback) {
	const vv = window.visualViewport
	if (!vv) {
		callback({ open: null, reason: 'no-visualViewport' })
		return function () {}
	}
	let lastH = vv.height
	const onResize = function () {
		const h = vv.height
		const open = h < lastH - 80
		lastH = h
		callback({ open, height: h })
	}
	vv.addEventListener('resize', onResize)
	vv.addEventListener('scroll', onResize)
	return function cleanup() {
		vv.removeEventListener('resize', onResize)
		vv.removeEventListener('scroll', onResize)
	}
}
